module.exports = __webpack_public_path__ + "static/media/Community.64bb49ea.png";